import { HttpClient } from '@angular/common/http';
import { Base } from '../base';

export class Oracles extends Base {
  constructor(protected httpClient: HttpClient, private parent: string) {
    super(httpClient, `${parent}/oracles`);
  }

  getSignedData() {
    return this.api.get('signed_data');
  }
}
